export default "__VITE_ASSET__BBj3_dvu__"